import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const ReloadLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-refetch'
      text={t('ticketProviderTicketPage.reloadTicketLink')}
    />
  )
}

ReloadLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default ReloadLink
